import React from 'react'
import { FaPhoneAlt } from 'react-icons/fa'
import { FaAddressCard } from 'react-icons/fa6'
import { MdAccessTimeFilled, MdEmail } from 'react-icons/md'

function Contact() {
  return (
    <>
    <div className="container my-4">
      <div className="row">
        <div className="col-md-6">
          <h2>Contact Information</h2>
          <div className="row">
            <div className="col-md-6 d-flex align-items-start mb-3">
              <FaAddressCard style={{ fontsize: "30px", marginRight: "10px", color: "#007bff" }} />
              <div>
                <strong>Address:</strong>
                <p>Sikar, Rajasthan</p>
                <iframe src="https" width="500"
                height="300"></iframe>
              </div>
            </div>

            <div className="col-md-6 d-flex align-items-start mb-3">
              <FaPhoneAlt style={{ fontSize: "30px", marginRight: "10px", color: "#28a745" }} />
              <div>
                <strong>Phone:</strong>
                <p>+91 9999999999</p>
              </div>
            </div>

            <div className="col-md-6 d-flex align-items-start mb-3">
              <MdEmail style={{ fontSize: "30px", marginRight: "10px", color: "#dc3545" }} />
              <div>
                <strong>Email:</strong>
                <p>ankit@gmail.com</p>
              </div>
            </div>

            <div className="col-md-6 d-flex align-items-start mb-3">
              <MdAccessTimeFilled style={{ fontSize: "30px", marginRight: "10px", color: "#ffc107" }} />
              <div>
                <strong>Working Hours:</strong>
                <p>Mon-Fri, 9AM - 5PM</p>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <h2>Get in Touch</h2>
          <form>
            <div className="mb-3">
              <label htmlFor="name" className="form-label">
                Name 
              </label>
              <input
                type="text"
                className="form-control"
                id="name"
                placeholder="Enter your name"
                />
                </div>
                <div className="mb-3">
                <label htmlFor="mobile number" className="form-label">
                  Moblie Number
                </label>
                <input
                  type="number"
                  placeholder="Enter your mobile number"
                  />
            </div>
            <div className="mb-3">
              <label htmlFor="email" className="form-label">
                Email 
              </label>
              <input
                type="email"
                className="form-control"
                id="email"
                placeholder="Enter your email"
                />
            </div>
            <div className="mb-3">
              <label htmlFor="message" className="form-label">
                Message
              </label>
              <textarea
                className="form-control"
                id="message"
                rows="4"
                placeholder="Write your message here">
                </textarea>
            </div>
            <button type="submit" className="btn btn-primary">
              Submit
            </button>
          </form>
        </div>
      </div>
    </div>
    </>
  )
}

export default Contact
